import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const ExternalLinksLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.external_links',
    link: '/further/ressources-supplementaires',
    icon: 'navigation-link__external-links',
});